import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_stationery_paper: FaireThemeEntity = {
  token: "discovery_theme_stationery-paper",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Stationery & Paper Goods",
  description: "Beautiful paper goods and writing essentials",
  bgColor: "#D4D8F0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
